import { useContext } from 'react';

import { useInfiniteQuery } from '@tanstack/react-query';
import axios from 'axios';

import { ConfigContext } from '../../../../aurr/contexts/ConfigContext';
import LoginContext from '../../../../aurr/contexts/LoginContext';
import { REPLIES_QUERY_KEY } from '../../constants';
import {
  KhorosPaginatedProps,
  KhorosTopicProps,
} from '../../interface/khoros.interface';
import { useKhorosUser } from '../useKhorosUser';

export const useKhorosPosts = ({
  topicId,
  baseURL,
  pageSize,
}: KhorosTopicProps & KhorosPaginatedProps) => {
  const { KHOROS_API } = useContext(ConfigContext);
  const { access_token, isUserLoading } = useContext(LoginContext);
  const axiosConfig = {
    baseURL: baseURL || KHOROS_API,
    headers: {
      ...(access_token && { authorization: `Bearer ${access_token}` }),
      'Cache-Control': 'no-cache, max-age=0',
    },
  };

  const { isLoading: khorosUserLoading } = useKhorosUser({
    baseURL,
  });

  const { isLoading: getIsLoading, ...rest } = useInfiniteQuery({
    queryKey: [REPLIES_QUERY_KEY, { topicId }],
    queryFn: async ({ pageParam = 0 }) => {
      const response = await axios.get(
        `/services/v2/community/khoros/replies?id=${topicId}&sortdir=desc&limit=${pageSize}&offset=${
          pageParam * pageSize
        }`,
        axiosConfig
      );
      return response?.data || undefined;
    },
    enabled: !isUserLoading,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.has_next_page === true) {
        return allPages.length;
      }
      return undefined;
    },
  });

  const waitingForUser = access_token && khorosUserLoading;

  return {
    isLoading: waitingForUser || getIsLoading,
    ...rest,
  };
};
